import { IToolInfo } from './IToolInfo';
import { RoleType } from '../../user/models/UserRole';
import { AccountUserType } from './AccountUserType';
import { UserRoles } from './UserRoles';

export interface UserInvitation {
  email: string;
  userId?: string;
  toolsPermissions?: IToolInfo[];
  accountId?: string;
  roles: string[];
  type?: RoleType;
}

export interface StaffUserInvitation {
  email: string;
  name?: string;
  userId?: string;
  accountId?: string;
  toolsPermissions?: IToolInfo[];
  roles: UserRoles[];
  sections: string[];
  accountUserType?: AccountUserType;
  expires?: string;
}

export const StaffUserInviteOptions = [
  { value: 8, text: '8 hours' },
  { value: 24, text: '1 day' },
  { value: 48, text: '2 days' },
  { value: 72, text: '3 days' },
  { value: 168, text: '7 days' },
];

export const PartnerUserInviteOptions = [
  { value: 8, text: '8 hours' },
  { value: 24, text: '1 day' },
  { value: 48, text: '2 days' },
  { value: 72, text: '3 days' },
  { value: 168, text: '7 days' },
  { value: 336, text: '14 days' },
  { value: 840, text: '35 days' },
];
